(
function (skyward, $, undefined)
{
    "use strict";
    var _addReadOnlyProperties = function(target, properties)
    {
        var definitions = {};
        $.each(properties || {}, function (k) { definitions[k] = { value: this }; });
        return Object.defineProperties(target, definitions);
    };
    
    var _makePrototype = function (parentConstructor, target)
    {
        var base = parentConstructor;
        var result = function ()
        {
            var i = arguments.length, args = new Array(i); while (i--) args[i] = arguments[i];

            // Here, "arguments" refers to the arguments provided *later*, when "new" is called on the constructor returned by this utility
            var exposedActions = base.apply(this, args);
            exposedActions = $.extend(exposedActions, target.apply(this, args));
            // Unless we implement some "intelligent" way to merge exposed actions returned by parent and child 
            //  the functions returned from target.constructor don't "override" base functions of the same name.
            //  instead, they replace them, much like the way C# interprets "new" vs "override" method declarations
            //  (One solution would be a $.map that wraps duplicate ctors in a "wrapper function" that calls child.ctor(), then base.ctor())

            if (typeof (exposedActions) === "object")
            {
                _addReadOnlyProperties(this, exposedActions);
            }
        };
        result.prototype = Object.create(base.prototype);
        return result;
    };

    _addReadOnlyProperties(skyward, {
        "mvvm": _addReadOnlyProperties({}, {
            // Low-level prototypes for the Observer-Pattern. 
            // Only use these as a temporary solution when a full MVVM implementation is not feasible.
            "newObservable": function (optional_constructor)
            {
                var prototype = (typeof (optional_constructor) === "function") ? _makePrototype(_observable, optional_constructor) : _observable;
                return new prototype();
            },
            "newObserver": function (optional_constructor)
            {
                var prototype = (typeof (optional_constructor) === "function") ? _makePrototype(_observer, optional_constructor) : _observer;
                return new prototype();
            },
            "newObservableCollection": function (optional_constructor)
            {
                var prototype = (typeof (optional_constructor) === "function") ? _makePrototype(_observableCollection, optional_constructor) : _observableCollection;
                return new prototype();
            },
            // MVVM Prototypes
            // A constructor is optional.
            // If provided, the constructor can return a dictionary of functions, and they will automatically be exposed as public methods on the new object.
            "newModel": function (observableProperties, readOnlyProperties, optional_constructor)
            {
                var prototype = (typeof (optional_constructor) === "function") ? _makePrototype(_model, optional_constructor) : _model;
                return new prototype(observableProperties, readOnlyProperties);
            },
            "newView": function (optional_constructor)
            {
                var prototype = (typeof (optional_constructor) === "function") ? _makePrototype(_model, optional_constructor) : _model;
                return new prototype();
            },
            "newViewModel": function (optional_constructor) // This really needs to be a combination model/observer. Right now there's no way to listen to another viewModel's state (i.e. IsValid for a collection of viewModels)
            {
                var prototype = (typeof (optional_constructor) === "function") ? _makePrototype(_observer, optional_constructor) : _observer;
                return new prototype();
            },
            "newModelCollection": function (collectees, publicProperties, readOnlyProperties, optional_constructor)
            {
                var prototype = (typeof (optional_constructor) === "function") ? _makePrototype(_modelCollection, optional_constructor) : _modelCollection;
                return new prototype(collectees, publicProperties, readOnlyProperties);
            },
            "utilities": _addReadOnlyProperties({}, {
                "makePrototype": _makePrototype,
                "addReadOnlyProperties": _addReadOnlyProperties
            })
        })
	});

	var _currentObserverID = 1;
	function _observer()
	{
		var _self = this;
		var _callbacks = {};
		var _observables = {};

		Object.defineProperties(_self, {
		    "_observerID": {
		        value: _currentObserverID++,
		        writable: false,
		        configurable: false
		    }
		});

		_addReadOnlyProperties(_self,{ 
		    "notify": function ()
		    {
		        var i = arguments.length, args = new Array(i); while (i--) args[i] = arguments[i];

		        var observable = this;
		        var event = args[0];

		        if (observable instanceof _observable && _callbacks[observable._observableID])
		        {
		            var id = observable._observableID;
		            if (event != undefined && typeof (_callbacks[id][event]) === "function")
		            {
		                // event-specific handlers don't get passed the event name
		                i = arguments.length - 1;
		                var argsMinusEventName = new Array(i); while (i--) argsMinusEventName[i] = arguments[i + 1];
                        _callbacks[id][event].apply(observable, argsMinusEventName);
		            }

		            // [undefined] is where the "any change" observer lives
		            if (_callbacks[id] && typeof (_callbacks[id][undefined]) === "function")
		            {
		                _callbacks[id][undefined].apply(observable, args);
		            }
		        }
		        return _self;
		    },
		    "observe": function (observable, callback_OrEventName, callback_IfEventNameSpecified)
		    {
		        if (observable instanceof _observable)
		        {
		            var id = observable._observableID;

		            if (typeof (callback_OrEventName) === 'object') // Allow an event object, in the format { "event1": callback, "event 2": callback ... etc } to be passed in
		            {
		                $.each(callback_OrEventName, function (e, cb)
		                {
		                    _self.observe(observable, e, cb);
		                });
		            }
                    else if (typeof (callback_OrEventName) === "function") // "All events" observer is registered by passing in a callback as the first parameter
		            {
		                observable.registerObserver(_self);
		                _observables[id] = observable;
		                (_callbacks[id] = _callbacks[id] || {})[undefined] = callback_OrEventName;
		            }
                    else if (typeof (callback_OrEventName) === "string" && typeof (callback_IfEventNameSpecified) === "function") // Property watchers are registered by passing in the property name and a callback
		            {
		                observable.registerObserver(_self);
		                _observables[id] = observable;
		                (_callbacks[id] = _callbacks[id] || {})[callback_OrEventName] = callback_IfEventNameSpecified;
		            }
		        }
		        return _self;
		    },
		    "stopObserving": function (observable)
		    {
				if (observable instanceof _observable)
		        {
		            observable.unregisterObserver(_self);
		            delete _callbacks[observable._observableID];
		            delete _observables[observable._observableID];
		        }
		    },
		    // stopObservingEvent(observable, undefined) will stop the "all events" observer
		    // use stopObservingObject() to remove callbacks for a specific observable (this will also unregister the observer from the observable)
		    "stopObservingEvent": function (observable, /*optional*/event)
		    {
		        if (observable instanceof _observable && _callbacks[observable._observableID])
		        {
		            var id = observable._observableID;
		            if (typeof (event) === "object") // An event-collection { eventName : callback, [...] } may also be passed in here
		            {
		                $.each(event, function (e)
		                {
		                    _self.stopObservingEvent(observable, e);
		                });
		            }
		            else
		            {
		                delete _callbacks[id][event];

		                if (!Object.keys(_callbacks[id]).length) // unregister from the observable only if we no longer watch *any* events on the observable.
		                {
		                    observable.unregisterObserver(_self);
		                    delete _callbacks[id];
		                    delete _observables[id];
		                }
		            }
		        }
		        return _self;
		    },
		    "stopObservingEverything": function ()
		    {
		        Object.keys(_observables).forEach(function (id)
		        {
		            _observables[id].unregisterObserver(_self);
		            delete _callbacks[id];
		            delete _observables[id];
		        });
		    }
		});
	}

	var _currentObservableID = 1;
	function _observable()
	{
		var _self = this;
		var _observers = {};
		var _isMuted = false;

		Object.defineProperties(_self, {
		    "isMuted": {
		        get : function ()
		        {
		            return (_isMuted ? true : false);
		        },
		        set: function (value)
		        {
		            _isMuted = (value ? true : false);
		        }
		    }
		});

		_addReadOnlyProperties(_self, {
		    "_observableID": _currentObservableID++,
		    "registerObserver": function (observer)
		    {
		        if (observer instanceof _observer)
		        {
		            _observers[observer._observerID] = observer;
		        }
		        return _self;
		    },
		    "unregisterObserver": function (observer)
		    {
		        if (observer instanceof _observer)
		        {
		            delete _observers[observer._observerID];
		        }
		        return _self;
		    },
		    "announce": function (/* eventName, [params...] */) // parameters are handled dynamically via the arguments object.
		    {
		        if (!_isMuted)
		        {
		            var i = arguments.length, args = new Array(i); while (i--) args[i] = arguments[i];

		            $.each(_observers, function (i, o)
		            {
		                o.notify.apply(_self, args);
		            });
		            return _self;
		        }
		    }
		});
	}

	function _observableCollection(collectionContents)
	{
	    var _self = this;
	    if (!_self._observableID)
		{
			_observable.call(_self);
		}
		var _collection = [];
		var _collectionObserver = new _observer();

		var _contentChanged = function ()
		{
		    var i = arguments.length, args = new Array(i); while (i--) args[i] = arguments[i];

		    // 'this' points to the observable in the collection that announced
		    _self.announce("contentChanged", this, args);
		    // Callbacks are executed with "this" set to the observable collection, and are passed the following 3 values:
		    //  the event name: "contentChanged", 
		    //  the observable in the collection responsible for the announcement, 
		    //  an array containing the original values from that observable's announcement [argument 1, argument 2, etc]) ... 
		};

	    // Connect our collectionObserver to each of the passed-in observables
		$.each(collectionContents || [], function (i, o)
		{
			if (o instanceof _observable)
			{
				_collection.push(o);
				_collectionObserver.observe(o, _contentChanged);
			}
		});

		Object.defineProperties(_self, { "length": { get: function () { return _collection.length; } }});

		var actions = {
		    "add": function (observable)
		    {
		        var length;
		        if (observable instanceof _observable)
		        {
		            length = _collection.push(observable);
		            _collectionObserver.observe(observable, _contentChanged);
		            _self.announce("add", observable, length);
		        }
		        return length;
		    },
		    "remove": function (observable)
		    {
		        var removedObservable;
		        if (observable instanceof _observable)
		        {
		            var index = _collection.indexOf(observable);
		            if (index != -1)
		            {
		                removedObservable = _collection.splice(index, 1)[0];
		                _collectionObserver.stopObserving(observable);
		                _self.announce("remove", observable, index);
		            }
		        }
		        return removedObservable;
		    },
		    "elementAt": function (index) { return _collection[index]; },
		    "find": function (delegate, context)
		    {
		        var result;
		        $.each(_collection, function ()
		        {
		            if (delegate(this, context))
		            {
		                result = this;
		                return false;
		            }
		        });
		        return result;
		    },
		    "findMany": function (delegate, context)
		    {
		        var results = [];
		        $.each(_collection, function ()
		        {
		            if (delegate(this, context))
		            {
		                results.push(this);
		            }
		        });
		        return results;
		    },
		    "indexOf": function (observable) { return _collection.indexOf(observable); },
		    "forEach": function (delegate) { return _collection.forEach(delegate); },
		    "filter": function (delegate) { return _collection.filter(delegate); },
		    "sort": function (comparator) { _collection.sort(comparator); _self.announce("sort"); },
		    "some": function (condition) { return _collection.some(condition); }
		};

		_addReadOnlyProperties(_self, actions);
	}
	_observableCollection.prototype = Object.create(_observable.prototype);

	function _model(properties, readOnlyProperties)
	{
	    var _self = this;
	    _observable.call(_self, properties, readOnlyProperties);
		var _properties = {};
		var _originalValues = {};
		var _originalValuesJSON = {};
		var _dirtyProperties = {};

		this.notifyOnSetToSameValue = true;

		// Wrap properties in getters/setters
		$.each(properties || {}, function (propertyName, currentValue)
		{
			_properties[propertyName] = currentValue;

			Object.defineProperty(_originalValues, propertyName, { value: currentValue });
			Object.defineProperty(_originalValuesJSON, propertyName, { value: JSON.stringify(currentValue) });

			Object.defineProperty(_self, propertyName, {
			    get: function () { return _properties[propertyName]; },
				set: function (val)
				{
				    if (_originalValuesJSON[propertyName] != JSON.stringify(val))
				    {
				        _dirtyProperties[propertyName] = true;
				    }
				    else
				    {
				        delete _dirtyProperties[propertyName];
				    }

					var oldVal = _properties[propertyName];
					_properties[propertyName] = val;
					if (val != oldVal || val == oldVal && this.notifyOnSetToSameValue)
					{
						_self.announce(propertyName, val, oldVal);
					}
				},
				enumerable: true
			});
		});
		$.each(readOnlyProperties || {}, function (propertyName, value)
		{
			_properties[propertyName] = value;

			var propertyDefinition;
			if(typeof(value) === "function")
			{
				propertyDefinition = { value: value };
			}
			else
			{
				Object.defineProperty(_originalValues, propertyName, { value: value });
				propertyDefinition = {
				    get: function () { return _properties[propertyName]; },
					enumerable: true
				};
			}
			Object.defineProperty(_self, propertyName, propertyDefinition);
		});

		Object.defineProperties(_self, {
			"originalValues": {
				value: _originalValues
			},
			"revert": {
				value: function()
				{
					for (var propertyName in _dirtyProperties)
					{
						_self[propertyName] = _originalValues[propertyName];
					}
				},
				configurable:true // This property gets overridden by modelCollection
			},
			"isDirty": {
				value: function ()
				{
				    return !$.isEmptyObject(_dirtyProperties);
				},
				configurable: true
			}
		});
	}
	_model.prototype = Object.create(_observable.prototype);

	function _modelCollection(models, properties, readOnlyProperties)
	{
	    var _self = this;
	    _model.call(_self, properties, readOnlyProperties);
		
	    var _modelCollectionObserver = new _observer();
		var _originalCollection = [];
		var _typeFilteredModels = [];

		$.each(models || {}, function (i, m)
		{
			if (m instanceof _model)
			{
				_originalCollection.push(m);
				_typeFilteredModels.push(m);
			}
		});
		_observableCollection.call(_self, _typeFilteredModels);

		_modelCollectionObserver.observe(_self, function (eventName, nestedModel, nestedArguments) // This works for Models, not nested ModelCollections' Models. If this functionality is needed, see observableCollection for one possible way to solve this 
		{
		    var nestedEventName = (nestedArguments || [])[0];
		    // the first argument an observable passes is the event name 
		    if (eventName == "contentChanged" && nestedEventName && nestedArguments.length >= 3 &&
                (JSON.stringify(nestedArguments[1]) !=JSON.stringify( nestedArguments[2])))
		    {
		        _self.announce("model:" + nestedEventName, nestedModel);
		    }
		});

		delete _self.isDirty; // These methods get replaced.
		delete _self.revert;
		_addReadOnlyProperties(_self, {
		    "originalModels": function ()
		    {
		        return _originalCollection.concat([]);
		    },
		    "revert": function ()
		    {
		        _self.forEach(function (model) { _self.remove(model); });
		        _originalCollection.forEach(function (model) { self.add(model); model.revert(); });
		    },
		    "isDirty": function ()
		    {
		        return _self.some(function (model) { return (model.isDirty()); });
		    }
		});
	}
	_modelCollection.prototype = Object.create(_observableCollection.prototype);

}(window.skyward = window.skyward || {}, window.jQuery)
);
